var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCardSend = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1757 13.1757C17.4101 12.9414 17.79 12.9414 18.0243 13.1757L19.6243 14.7757C19.8586 15.0101 19.8586 15.39 19.6243 15.6243C19.3899 15.8586 19.0101 15.8586 18.7757 15.6243L18.2 15.0485V18.4C18.2 18.7314 17.9314 19 17.6 19C17.2686 19 17 18.7314 17 18.4V15.0485L16.4243 15.6243C16.1899 15.8586 15.8101 15.8586 15.5757 15.6243C15.3414 15.39 15.3414 15.0101 15.5757 14.7757L17.1757 13.1757Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 5.60001H13.6C16.617 5.60001 18.1255 5.60001 19.0627 6.53726C19.7376 7.2121 19.9265 8.18306 19.9794 9.80001H4.02057C4.07348 8.18306 4.26243 7.2121 4.93726 6.53726C5.87452 5.60001 7.38301 5.60001 10.4 5.60001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 18.4H13.6C14.4447 18.4 15.1712 18.4 15.8 18.3794V16.9889C15.4081 16.9454 15.0277 16.7733 14.7272 16.4728C14.0243 15.7699 14.0243 14.6302 14.7272 13.9272L16.3272 12.3272C17.0302 11.6243 18.1698 11.6243 18.8728 12.3272L19.995 13.4494C20 13.0091 20 12.5276 20 12C20 11.6465 20 11.3136 19.9985 11H4.00151C4 11.3136 4 11.6465 4 12C4 15.017 4 16.5255 4.93726 17.4627C5.87452 18.4 7.38301 18.4 10.4 18.4ZM6.6 15.2C6.6 14.8686 6.86863 14.6 7.2 14.6H10.4C10.7314 14.6 11 14.8686 11 15.2C11 15.5314 10.7314 15.8 10.4 15.8H7.2C6.86863 15.8 6.6 15.5314 6.6 15.2ZM12.4 14.6C12.0686 14.6 11.8 14.8686 11.8 15.2C11.8 15.5314 12.0686 15.8 12.4 15.8H13.6C13.9314 15.8 14.2 15.5314 14.2 15.2C14.2 14.8686 13.9314 14.6 13.6 14.6H12.4Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCardSend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CardSend.45bb233a.svg";
export { ForwardRef as ReactComponent };